module.exports = __webpack_public_path__ + "img/d-ftop-en.2ffddd46.jpg";